"use client";

import React, { useState } from 'react';

export default function ContactSection() {
  const [form, setForm] = useState({ email: '', question: '' });
  const [sent, setSent] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSent(true);
    setForm({ email: '', question: '' });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="page-width">
        <div className="contact-inner">
          <div className="contact-text">
            <h2 className="contact-title">Contact Us</h2>
            <p className="contact-desc">
              Have a question about our coffee, an order, or just want to say hello?
              Drop us a message and we&apos;ll get back to you as soon as we can.
            </p>
            <div className="contact-detail">
              <span className="contact-detail__label">Location</span>
              <span>327 Highway 98, Eastpoint, FL 32328</span>
            </div>
            <div className="contact-detail">
              <span className="contact-detail__label">Hours</span>
              <span>Mon–Fri 7am–12:30pm · Sat 8am–2pm</span>
            </div>
          </div>

          <div className="contact-form-wrap">
            {sent ? (
              <div className="sent-msg">
                <div className="sent-icon">✓</div>
                <p className="sent-title">Message sent!</p>
                <p className="sent-sub">We&apos;ll be in touch soon.</p>
                <button className="reset-btn" onClick={() => setSent(false)}>Send another</button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="cf-field">
                  <label className="cf-label" htmlFor="cf-email">Email Address</label>
                  <input
                    id="cf-email"
                    className="cf-input"
                    type="email"
                    placeholder="your@email.com"
                    required
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                  />
                </div>
                <div className="cf-field">
                  <label className="cf-label" htmlFor="cf-question">Your Question</label>
                  <textarea
                    id="cf-question"
                    className="cf-textarea"
                    placeholder="Ask us anything about our coffee, shipping, or locations…"
                    rows={5}
                    required
                    value={form.question}
                    onChange={(e) => setForm({ ...form, question: e.target.value })}
                  />
                </div>
                <button type="submit" className="cf-submit">Send Message</button>
              </form>
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        .contact-section {
          padding: 60px 0;
          background: #f9f9f9;
          font-family: 'Work Sans', sans-serif;
        }
        .page-width {
          max-width: 1100px;
          margin: 0 auto;
          padding: 0 30px;
        }
        .contact-inner {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
          align-items: start;
        }
        .contact-title {
          font-size: 22px;
          font-weight: 600;
          color: #3d4246;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin: 0 0 16px;
        }
        .contact-desc {
          font-size: 15px;
          color: #61696f;
          line-height: 1.7;
          margin: 0 0 28px;
        }
        .contact-detail {
          display: flex;
          flex-direction: column;
          gap: 2px;
          margin-bottom: 14px;
          font-size: 14px;
          color: #3d4246;
        }
        .contact-detail__label {
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          font-size: 12px;
          color: #557b97;
        }
        .contact-form-wrap {
          background: #fff;
          border: 1px solid #e8e9eb;
          padding: 32px;
        }
        .contact-form {
          display: flex;
          flex-direction: column;
          gap: 18px;
        }
        .cf-field {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }
        .cf-label {
          font-size: 12px;
          font-weight: 600;
          color: #3d4246;
          text-transform: uppercase;
          letter-spacing: 0.04em;
        }
        .cf-input,
        .cf-textarea {
          padding: 10px 14px;
          border: 1px solid #dcdcdc;
          font-size: 15px;
          font-family: 'Work Sans', sans-serif;
          color: #3d4246;
          background: #fff;
          outline: none;
          transition: border-color 0.2s;
          resize: vertical;
        }
        .cf-input:focus,
        .cf-textarea:focus {
          border-color: #557b97;
        }
        .cf-submit {
          padding: 12px 28px;
          background: #557b97;
          color: #fff;
          border: none;
          cursor: pointer;
          font-size: 15px;
          font-family: 'Work Sans', sans-serif;
          font-weight: 600;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          transition: background 0.2s;
          align-self: flex-start;
        }
        .cf-submit:hover {
          background: #3d4246;
        }
        .sent-msg {
          text-align: center;
          padding: 40px 20px;
        }
        .sent-icon {
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background: #557b97;
          color: #fff;
          font-size: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 16px;
        }
        .sent-title {
          font-size: 20px;
          font-weight: 600;
          color: #3d4246;
          margin: 0 0 8px;
        }
        .sent-sub {
          font-size: 15px;
          color: #61696f;
          margin: 0 0 20px;
        }
        .reset-btn {
          background: none;
          border: 1px solid #557b97;
          color: #557b97;
          padding: 8px 20px;
          cursor: pointer;
          font-size: 14px;
          font-family: 'Work Sans', sans-serif;
          font-weight: 500;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          transition: background 0.2s, color 0.2s;
        }
        .reset-btn:hover {
          background: #557b97;
          color: #fff;
        }
        @media (max-width: 749px) {
          .contact-inner {
            grid-template-columns: 1fr;
            gap: 32px;
          }
          .contact-form-wrap {
            padding: 24px;
          }
        }
      `}</style>
    </section>
  );
}
